export const updateCollection = (collection, newKey) => {
	return collection.map((obj) => ({ ...obj, ...newKey }));
};
